export function isCrawler() {
    const userAgent = navigator.userAgent.toLowerCase();
    const botPatterns = /bot|gpt|perplexity|openai|crawl|spider|slurp|mediapartners|adsbot|google|bing|yandex|baidu|duckduckgo|facebook|twitter|linkedin|embedly|quora|pinterest|reddit|snapchat|whatsapp|telegram|slack|discord|skype|applebot|petalbot|semrush|ahrefs|mj12bot|sogou|qwant|yahoo|seznambot|teoma|gigablast|ia_archiver|archive.org_bot|python-requests|curl|wget|postman/i;

    return botPatterns.test(userAgent);
}